<div
  id="group-assignment-management-component"
  class="component-inner-wrapper group-assignment-component-class"
>
  <main class="main-content">
    <div class="container">
      <div class="breadcrumb">
        <span class="ele_link" [routerLink]="['/user-management/customers']"
          >USER MANAGEMENT</span
        >
        <span>></span>
        <span>Customer Group Management</span>
      </div>

      <h1 class="page-title mb-4">Customer Group Management</h1>

      <div class="group-assignment-card">

        <!-- Choose Customer -->
        <div class="form-group customer-select-group">
          <label class="form-label">Choose Customer</label>
          <div class="select-wrapper">
            <select
              class="form-control custom-dropdown"
              [(ngModel)]="selectedCustomerId"
              (ngModelChange)="onCustomerChange()"
              [disabled]="isLoadingCustomers"
            >
              <option value="">
                {{ isLoadingCustomers ? 'Loading customers...' : '-- Select Customer --' }}
              </option>
              <option *ngFor="let c of customers" [value]="c.id">
                {{ c.customerName }}
              </option>
            </select>
          </div>
        </div>

        <!-- Loading indicator -->
        <div *ngIf="isLoadingGroups" class="loading-state">
          <span>Loading groups...</span>
        </div>

        <!-- Dual panel (shown only when a customer is selected) -->
        <ng-container *ngIf="!isLoadingGroups">
          <div class="dual-panel-wrapper" [class.panels-disabled]="!selectedCustomerId">

            <!-- LEFT: Existing Groups -->
            <div class="panel">
              <div class="panel-header">
                <span class="panel-title">
                  Existing Groups
                  <span class="panel-count">({{ existingGroups.length }})</span>
                </span>
                <div class="panel-search">
                  <mat-icon class="search-icon">search</mat-icon>
                  <input
                    type="text"
                    class="form-control search-input"
                    placeholder="Search"
                    [(ngModel)]="existingSearch"
                    [disabled]="!selectedCustomerId"
                  />
                </div>
              </div>
              <div class="panel-list">
                <div
                  *ngFor="let g of filteredExisting"
                  class="panel-item"
                  [class.selected]="isExistingSelected(g.id)"
                  (click)="toggleExisting(g)"
                >
                  <span class="group-name-text">{{ g.groupName }}</span>
                  <span
                    class="group-type-label"
                    [class.label--public]="g.isCommon"
                    [class.label--private]="!g.isCommon"
                  >{{ g.isCommon ? 'Public' : 'Private' }}</span>
                </div>
                <div
                  *ngIf="selectedCustomerId && filteredExisting.length === 0"
                  class="panel-empty"
                >
                  {{ existingSearch ? 'No matching groups' : 'No groups assigned' }}
                </div>
                <div *ngIf="!selectedCustomerId" class="panel-empty">
                  Select a customer to view groups
                </div>
              </div>
            </div>

            <!-- Transfer Buttons -->
            <div class="transfer-buttons">
              <button
                type="button"
                class="transfer-btn"
                [disabled]="!selectedCustomerId || selectedExisting.length === 0"
                (click)="moveToAvailable()"
                title="Move selected to Available"
              >
                &gt;
              </button>
              <button
                type="button"
                class="transfer-btn"
                [disabled]="!selectedCustomerId || existingGroups.length === 0"
                (click)="moveAllToAvailable()"
                title="Move all to Available"
              >
                &gt;&gt;
              </button>
              <button
                type="button"
                class="transfer-btn"
                [disabled]="!selectedCustomerId || availableGroups.length === 0"
                (click)="moveAllToExisting()"
                title="Move all to Existing"
              >
                &lt;&lt;
              </button>
              <button
                type="button"
                class="transfer-btn"
                [disabled]="!selectedCustomerId || selectedAvailable.length === 0"
                (click)="moveToExisting()"
                title="Move selected to Existing"
              >
                &lt;
              </button>
            </div>

            <!-- RIGHT: Available Groups -->
            <div class="panel">
              <div class="panel-header">
                <span class="panel-title">
                  Available Groups
                  <span class="panel-count">({{ availableGroups.length }})</span>
                </span>
                <div class="panel-search">
                  <mat-icon class="search-icon">search</mat-icon>
                  <input
                    type="text"
                    class="form-control search-input"
                    placeholder="Search"
                    [(ngModel)]="availableSearch"
                    [disabled]="!selectedCustomerId"
                  />
                </div>
              </div>
              <div class="panel-list">
                <div
                  *ngFor="let g of filteredAvailable"
                  class="panel-item"
                  [class.selected]="isAvailableSelected(g.id)"
                  (click)="toggleAvailable(g.id)"
                >
                  <span class="group-name-text">{{ g.groupName }}</span>
                  <span
                    class="group-type-label"
                    [class.label--public]="g.isCommon"
                    [class.label--private]="!g.isCommon"
                  >{{ g.isCommon ? 'Public' : 'Private' }}</span>
                </div>
                <div
                  *ngIf="selectedCustomerId && filteredAvailable.length === 0"
                  class="panel-empty"
                >
                  {{ availableSearch ? 'No matching groups' : 'No groups available' }}
                </div>
                <div *ngIf="!selectedCustomerId" class="panel-empty">
                  Select a customer to view groups
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Action Buttons -->
        <div class="button-container">
          <button
            type="button"
            class="btn-cancel"
            (click)="onCancel()"
            [disabled]="isSaving"
          >
            Undo
          </button>
          <button
            type="button"
            class="btn-confirm"
            (click)="onSave()"
            [disabled]="!selectedCustomerId || isSaving"
          >
            {{ isSaving ? 'Saving...' : 'Save' }}
          </button>
        </div>

      </div>
    </div>
  </main>
</div>
